(function () {
  function updateFreeShippingBanners(cart) {
    document.querySelectorAll('.free-shipping-banner').forEach((el) => {
      const threshold = Number(el.dataset.threshold || 0);
      if (cart.items_subtotal_price == null) return;
      const remaining = Math.max(threshold - cart.items_subtotal_price, 0);
      const span = el.querySelector('span');

      if (!span) return;

      span.innerHTML =
        remaining === 0 ? 'Eligible for free shipping' : `${formatMoney(remaining)} away from free shipping`;

      el.classList.remove('is-loading');

      // Update progress bar width and color
      var progressBar = el.querySelector('.free-shipping-progress__bar');
      if (progressBar) {
        var total = cart.items_subtotal_price || 0;
        var thresh = threshold || 0;
        var percent = thresh > 0 ? Math.min((total * 100) / thresh, 100) : 0;
        progressBar.style.width = percent + '%';

        progressBar.style.backgroundColor = percent < 100 ? '#BE9614' : '#9CC142';
      }
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: Shopify?.currency?.active || 'USD',
    }).format(cents / 100);
  }

  function fetchCartAndUpdate() {
    document.querySelectorAll('.free-shipping-banner').forEach((el) => el.classList.add('is-loading'));
    fetch('/cart.json', { cache: 'no-store' })
      .then((r) => r.json())
      .then(updateFreeShippingBanners);
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList.contains('drawer--cart')) {
          fetchCartAndUpdate();
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : args[0].url;
        if (url.includes('/cart')) {
          response.clone().json().then(updateFreeShippingBanners);
        }
      } catch (_) {}
      return response;
    };
  }

  fetchCartAndUpdate();

  document.documentElement.addEventListener('wetheme-cart-update', () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        updateFreeShippingBanners(cart);
      });
  });
})();
